<template>
	<div>
		<a-row class="">
			<div class="flex mt15 mb15" style="justify-content: space-between;">
                <div class="flex-width flex items-center">
                    <img src="../../../public/images/guigeguanli.png" style="width:25px;height:25px" />
                    <a-dropdown class="ml5">
                        <a class="ant-dropdown-link" @click="e => e.preventDefault()">
                            {{ select_item.name }} <a-icon type="down" />
                        </a>
                        <a-menu slot="overlay">
                            <a-menu-item>
                                <a href="javascript:;" @click="changeSelectItem(1)">全部付款申请</a>
                            </a-menu-item>
                            <a-menu-item>
                                <a href="javascript:;" @click="changeSelectItem(2)">我的待办</a>
                            </a-menu-item>
                        </a-menu>
                    </a-dropdown>
                </div>
                <div class="mr20 flex" style=""> 
                    <a-input-search size="small" allowClear class="" v-model="search" placeholder="请输入关键字" enter-button @change="allowCostClear" @search="onSearch" @pressEnter="onSearch"/>
                    <!-- <a-button class="ml10" style="background-color: #fd6363;color: white;" icon="sync" @click="">
                        导出
                    </a-button> -->
                    <a-button class="ml10" size="small" style="background-color: #fd6363;color: white;" icon="plus" @click="addProceeds">
                        新增
                    </a-button>
                </div>
            </div>
		</a-row>
		
		<a-row :gutter="24" type="flex" align="stretch">
			<a-col :span="24" :lg="30" class="mb-24">
				<a-card  :bordered="false" class="header-solid h-full" :bodyStyle="{padding: 0,}">
					<a-table :data-source="data" :columns="columns" class="pd15"  :pagination="false"  size="small" bordered>
                        <template slot="name" slot-scope="text,record">
                            <a @click="goCheckDetail(record.id)">{{ text }}</a>	
                        </template>
                        <template slot="operation" slot-scope="text,record">
                            <a v-if="record.return_type_id != 6" @click="goEditDetail(record.id)">编辑</a>	
                            <a-popconfirm ok-text="确定" cancel-text="取消" title="确认删除？" @confirm="() => goDeleteDetail(record.key)">
                                <a class="ml10">删除</a>
                            </a-popconfirm>	
                        </template>
					</a-table>
					<a-pagination 
						class="flex items-center mb10"
						style="justify-content: flex-end"
						show-quick-jumper  
						v-model="page.page" 
						:total="page.total" 
                        :page-size="30"
						@change="onShowSizeChange" 
					/>
				</a-card>
			</a-col>
		</a-row>
		<a-drawer
			title="新增付款申请·默认业务类型"
			:width="1200"
			:visible="visibleAddPlan"
			:body-style="{ paddingBottom: '80px' }"
			@close="onClose()"
		>
            <div>
                <a-form :form="form" layout="vertical" hide-required-mark>
                    <a-row :gutter="16" class="">
                        <a-col :span="12">
                            <a-form-item label="项目名称">
                                <a-select
                                    size="small"
                                    show-search
                                    v-model="paymentForm.data.project_id"
                                    option-filter-prop="children"
                                    :filter-option="filterOption"
                                    style="width: 100%"
                                    placeholder="请选择项目"
                                    @change="updateProjectSelect()"
                                > 
                                    <a-select-option v-for="item in projectList" :key="item.id">
                                        {{ item.name }} 
                                    </a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row :gutter="16" class="">
                        <a-col :span="12">
                            <a-form-item label="收款单位">
                                <a-input
                                    size="small"
                                    placeholder="包含关键字"
                                    v-model="paymentForm.data.shoukuan_company"
                                    style="width: 100%"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="收款人">
                                <a-input
                                    size="small"
                                    placeholder="包含关键字"
                                    v-model="paymentForm.data.shoukuan_person"
                                    style="width: 100%"
                                />
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row :gutter="16" class="">
                        <a-col :span="12">
                            <a-form-item label="付款内容">
                                <a-input
                                    size="small"
                                    placeholder="包含关键字"
                                    v-model="paymentForm.data.pay_content"
                                    style="width: 100%"
                                />
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row :gutter="16" class="">
                        <a-col :span="12">
                            <a-form-item label="开户银行">
                                <a-input
                                    size="small"
                                    placeholder="包含关键字"
                                    v-model="paymentForm.data.opening_bank"
                                    style="width: 100%"
                                />
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row :gutter="16" class="">
                        <a-col :span="12">
                            <a-form-item label="银行账号">
                                <a-input
                                    size="small"
                                    placeholder="包含关键字"
                                    v-model="paymentForm.data.bank_account"
                                    style="width: 100%"
                                />
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row :gutter="16" class="">
                        <a-col :span="12">
                            <a-form-item label="金额大写（佰 拾 万 仟 佰 拾 元 角 分）">
                                <a-input
                                    size="small"
                                    placeholder="包含关键字"
                                    v-model="paymentForm.data.amount_words"
                                    style="width: 100%"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="金额小写">
                                <a-input-number
                                    size="small"
                                    style="width:100%;"
                                    v-model="paymentForm.data.amount"
                                    :min="0" 
                                    :step="0.01"
                                    
                                />
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row :gutter="16" class="">
                        <a-col :span="12">
                            <a-form-item label="备注">
                                <a-textarea
                                    size="small"
                                    v-model="paymentForm.data.remark"
                                    placeholder="请输入备注"
                                    :auto-size="{ minRows: 3, maxRows: 5 }"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="附件">
                                <a-upload
                                    :action="upload_url"
                                    :before-upload="beforeUpload"
                                    class="upload-list-inline"
                                    @change="handleChange"
                                    :headers="headers"
                                >
                                    <a-button> <a-icon type="upload" /> 上传 </a-button>
                                </a-upload>
                            </a-form-item>
                        </a-col>
                    </a-row>
                </a-form>
            </div>
			<div
				:style="{
					position: 'absolute',
					right: 0,
					bottom: 0,
					width: '100%',
					borderTop: '1px solid #e9e9e9',
					padding: '10px 16px',
					background: '#fff',
					textAlign: 'right',
					zIndex: 1,
				}"
			>
				<a-button :style="{ marginRight: '8px' }" @click="onClose()">
					取消
				</a-button>
				<a-button type="primary" @click="goAddProceeds">
					保存
				</a-button>
			</div>
		</a-drawer>
        <a-drawer
            :width="1200"
            :visible="visibleCheckProceeds"
            :body-style="{ paddingBottom: '80px' }"
            @close="onClose()"
        >
            <div class="flex items-center mt20">
                <div class="flex">
                    <div class="flex">
                        <img class="mr10" src="../../../public/images/guigeguanli.png" style="width:25px;height:25px" />
                        <div class="fs16" style="font-weight: bolder;">{{ newProceeds.name }}</div>
                        <div class="ml20 mt2 fs14" style="color:grey">收款</div>
                    </div>
                </div>
                <div class="flex items-center" style="position: absolute;right:0">
                    <!-- <a-button @click="visibleCheckProceeds = false">关闭</a-button> -->
                    <!-- <a-button class="ml10" style="background-color: red;color: white;" @click="">打印</a-button> -->
                </div>
            </div>

            <a-divider />

            <a-tabs>
                <a-tab-pane tab="详情" :key="1">
                    <div>
                        <div>
                            <a-row :gutter="16" class="fs16 mt20">
                                <a-col :span="12">
                                    <div style="color:grey">项目名称</div>
                                    <div>{{((newProceeds.project_name != "")&&(newProceeds.project_name != null))?newProceeds.project_name:"--"}}</div>
                                </a-col>
                                <a-col :span="12">
                                    <div style="color:grey">项目合同</div>
                                    <div>{{((newProceeds.contract != "")&&(newProceeds.contract != null))?newProceeds.contract:"--"}}</div>
                                </a-col>
                                <!-- <a-col :span="12">
                                    <div style="color:grey">甲方单位</div>
                                    <div>{{((newProceeds.partA != "")&&(newProceeds.partA != null))?newProceeds.partA:"--"}}</div>
                                </a-col> -->
                            </a-row>
                            <a-row :gutter="16" class="fs16 mt20">
                                
                                <a-col :span="12">
                                    <div style="color:grey">收款类型</div>
                                    <div>{{((newProceeds.return_type != "")&&(newProceeds.return_type != null))?newProceeds.return_type:"--"}}</div>
                                </a-col>
                            </a-row>
                            <a-row :gutter="16" class="fs16 mt20">
                                <a-col :span="12">
                                    <div style="color:grey">收款金额</div>
                                    <div>{{((newProceeds.proceeds_amount != "")&&(newProceeds.proceeds_amount != null))?newProceeds.proceeds_amount:"--"}}</div>
                                </a-col>
                                <a-col :span="12">
                                    <div style="color:grey">收款时间</div>
                                    <div>{{((newProceeds.return_date != "")&&(newProceeds.return_date != null))?newProceeds.return_date:"--"}}</div>
                                </a-col>
                            </a-row>
                            <a-row :gutter="16" class="fs16 mt20">
                                <a-col :span="12">
                                    <div style="color:grey">收款方式</div>
                                    <div>{{((newProceeds.return_way != "")&&(newProceeds.return_way != null))?newProceeds.return_way:"--"}}</div>
                                </a-col>
                                <a-col :span="12">
                                    <div style="color:grey">备注</div>
                                    <div>{{((newProceeds.note != "")&&(newProceeds.note != null))?newProceeds.note:"--"}}</div>
                                </a-col>
                            </a-row>
                            <a-row :gutter="16" class="fs16 mt20">
                                <a-col :span="12">
                                    <div style="color:grey">附件</div>
                                    <div v-if="((newProceeds.attachment != null)&&(newProceeds.attachment != ''))">
                                        <div v-for="(item, index) in newProceeds.attachment" :key="index">{{ item }}</div>
                                    </div>
                                    <div v-else>--</div>
                                </a-col>
                                <a-col :span="12">
                                    <div style="color:grey">负责人</div>
                                    <div>{{((newProceeds.charge_person != "")&&(newProceeds.charge_person != null))?newProceeds.charge_person:"--"}}</div>
                                </a-col>
                            </a-row>
                        </div>
                        <a-divider />
                        <div>
                            <a-row :gutter="16" class="fs16 mt20">
                                <a-col :span="12">
                                    <div style="color:grey">创建人</div>
                                    <div>{{((newProceeds.create_person != "")&&(newProceeds.create_person != null))?newProceeds.create_person:"--"}}</div>
                                </a-col>
                                <a-col :span="12">
                                    <div style="color:grey">创建时间</div>
                                    <div>{{((newProceeds.create_time != "")&&(newProceeds.create_time != null))?newProceeds.create_time.replace("T", " "):"--"}}</div>
                                </a-col>
                            </a-row>
                        </div>
                    </div>
                </a-tab-pane>
            </a-tabs>
        </a-drawer>
	</div>
</template>

<script>
import CardCompanyMembers from "../../components/Cards/CardCompanyMembers.vue"
const KF = 'updatable';

	export default ({
		components: {
            CardCompanyMembers,
		},
		data() {
			return {
                form: this.$form.createForm(this),
				columns:[
					{
                        title: '序号',
                        dataIndex: 'key',
                    },
                    {
                        title: '项目名称',
                        dataIndex: 'project_name',
                        key: 'project_name',
                    },
                    {
                        title: '收款类型',
                        dataIndex: 'return_type',
                        key: 'return_type',
                    },
                    {
                        title: '收款时间',
                        dataIndex: 'return_date',
                        key: 'return_date',
                    },
                    {
                        title: '收款金额',
                        dataIndex: 'proceeds_amount',
                        key: 'proceeds_amount',
                    },
                    {
                        title: '收款方式',
                        dataIndex: 'return_way',
                        key: 'return_way',
                    },
                    {
                        title: '备注',
                        dataIndex: 'note',
                        key: 'note',
                    },
                   
                    {
                        title: '创建时间',
                        dataIndex: 'create_time',
                        key: 'create_time',
                    },
                   
					{
                        title: '操作',
                        dataIndex: 'operation',
                        key: 'operation',
                        scopedSlots: { customRender: 'operation' },
                    },
				],
				data:[],
				page:{page:1,total:0},
				search:"",
                editingKey:false,
				visibleAddPlan:false,
                visibleCheckProceeds:false,
				newProceeds:{},
                selectContract:{key:null, label:""},
                selectPartA:{key:null, label:""},
                selectReturnType:{key:null, label:""},
                selectReturnWay:{key:null, label:""},
                selectPerson:{key:null, label:""},
				selectProject:{key:null, label:""},
				selectMaterial:{key:null, label:"", current_count:0},
                contractList:[],
                partAList:[],
                projectList:[],
                returnType:[{key:1, label:"预付款"},{key:2, label:"进度款"},{key:3, label:"结算款"},{key:4, label:"质保金"},{key:5, label:"农名工专户"}, {key:7, label:"其他"}],
                returnWay:[{key:1, label:"现金"},{key:2, label:"转账"},{key:3, label:"银行承兑"},{key:4, label:"保理"},{key:5, label:"其他"}],
                personList:[],
                checkedKeysList:[],
                checkedKeys:[],
				uploading: false,
				upload_url: "",
				headers: {},
                fileList:[],
                select_type:"-1",
                select_item:{id:1, name:"全部付款申请"},
                paymentForm:{id:0, event_type:0, data:{project_id:null, project_name:null, shoukuan_company:null, shoukuan_person:null, pay_content:null, opening_bank:null, bank_account:null, amount_words:null, amount:0, remark:null, attachment:[]}, flowdata:[],}


			}
		},
        onload(){

        },
		created(){
			this.upload_url = this.$api.request_body.url + "/project/upload_assets";
			this.headers.token = this.$api.request_body.token;
            this.getProceedsRecord()
            this.getProjectList()
		},
		methods:{
			async getProceedsRecord(){
				let rs = await this.$api.getProceedsRecord(this.select_type, this.search, this.page.page - 1, 30)
                console.log(rs.data)
				if(rs.err == 0){
                    let ca = (this.page.page - 1) * 30 + 1
                    for(let item of rs.data){
                        item.proceeds_amount = item.proceeds_amount/100
                        item.key = ca
                        ca++
                    }
					this.data = rs.data
					this.page.total = rs.count
				}
			},
            async getContractList(key){
                console.log(key)
                let rs = await this.$api.getContractList(key)
                console.log(rs.data)
                if(rs.err == 0){
                    this.contractList = rs.data
                }
            },
            async getPartAList(){
                let rs = await this.$api.getPartAList()
                if(rs.err == 0){
                    this.partAList = rs.data
                }
            },
            async getProjectList(){
                let rs = await this.$api.getProjectList()
                console.log("454:")
                console.log(rs.data)
                if(rs.err == 0){
                    this.projectList = rs.data
                }
            },
            async getPersonList(){
                let rs = await this.$api.getCompanyMembers()
                console.log(rs.data)
                if(rs.err == 0){
                    this.personList = rs.data
                }
            },
            changeSelectItem(key){
                this.select_item.id = key
                this.select_item.name = (key==1)?"全部付款申请":"我的待办"
            },
			onSearch(){
				// if((this.search.length == 0)){
                //     this.$notification['warning']({
                //         message: '查询条件为空',
                //         description:
                //         '请输入查询关键词',
                //         style: {
                //             width: '600px',
                //             marginLeft: `${335 - 600}px`,
                //         },
                //     });
                //     return;
                // } else {
					this.getProceedsRecord()
                // }
			},
			onShowSizeChange(){
				if(this.search.length != 0){
                    this.onSearch()
                }else{
					this.page.page = 1
                    this.getProceedsRecord()
                }
			},
            async getProceedsDetail(key){
                let rs = await this.$api.getProceedsDetail(key)
                console.log(rs.data)
                if(rs.err == 0){
                    rs.data.proceeds_amount = rs.data.proceeds_amount/100
                    rs.data.attachment = JSON.parse(rs.data.attachment)
                    this.newProceeds = rs.data
                    if(this.paymentForm.data.attachment.length != 0){
                        for(let item of this.newProceeds.attachment){
                            let as = {}
                            as.uid = this.fileList.length + 1
                            as.name = item.url
                            as.status = "done"
                            as.url = item.url
                            this.fileList.push(as)
                        }
                    }

                    this.selectProject.key = rs.data.project_id 
                    this.selectProject.label = rs.data.project_name
                    this.selectContract.key = rs.data.contract_id
                    this.selectContract.label = rs.data.contract_name
                    this.selectPartA.key = rs.data.partA_id
                    this.selectPartA.label = rs.data.partA_name
                    this.selectReturnType.key = rs.data.return_type_id
                    this.selectReturnType.label = rs.data.return_type
                    this.selectReturnWay.key = rs.data.return_way_id
                    this.selectReturnWay.label = rs.data.return_way
                    this.selectPerson.key = rs.data.charge_user_id
                    this.selectPerson.label = rs.data.charge_person
 
                }
            },
		    async goCheckDetail(key){
                this.getProceedsDetail(key)
                this.visibleCheckProceeds = true
            },
            async goEditDetail(key){
                this.getProceedsDetail(key)
                // this.getContractList()
                // this.getPartAList()
                this.getPersonList()
                this.visibleAddPlan = true
            },
            goDeleteDetail(key){
                this.data = this.data.filter(it=> it.key != key)
            },
			addProceeds(){
                this.paymentForm = {id:0, event_type:0, data:{project_id:null, project_name:null, shoukuan_company:null, shoukuan_person:null, pay_content:null, opening_bank:null, bank_account:null, amount_words:null, amount:0, remark:null, attachment:[]}, flowdata:[],}
				this.visibleAddPlan = true;
			},
			async goAddProceeds(){
                console.log(this.paymentForm)
                // if(this.newProceeds.project_id == null){
                //     this.$notification['warning']({
                //         message: '未选择项目',
                //         style: {
                //             width: '600px',
                //             marginLeft: `${335 - 600}px`,
                //         },
                //     });
                //     return;
                // }
                return;
                let rs = await this.$api.goAddProceeds(this.newProceeds)
                if(rs.err == 0){
                    this.$message.success('保存成功')
                    this.visibleAddPlan = false
                    this.getProceedsRecord()
                }else{
                    this.$message.warn('保存失败，请检查后重试或联系管理员')
                }
			},
			allowCostClear(){
                if(this.search.length == 0){
                    this.page.page = 1;
                    this.getProceedsRecord()
                }
            },
			onClose(){
				this.visibleAddPlan = (this.visibleAddPlan)?false:false
				this.visibleCheckProceeds = (this.visibleCheckProceeds)?false:false
			},
            updateProjectSelect(){
                this.paymentForm.data.project_name = this.projectList.find(it=>it.id == this.paymentForm.data.project_id).name
                console.log(this.paymentForm)
            },
            async checkMaterialExist(){
                // let rs = await this.$api.checkMaterialExist(this.selectMaterial.key,)
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            beforeUpload(file) {
				const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
				if (!isJpgOrPng) {
					this.$message.error('只能上传PNG/JPEG');
				}
				return isJpgOrPng;
			},
            handleChange(info) {
				const status = info.file.status;
				if (info.file.status === 'uploading') {
					this.uploading = true;
					return;
				}
				if (status !== 'uploading') {
				}
				if (status === 'done') {
					if (info.file.response.err == 0) {
                        this.paymentForm.data.attachment = []
                        for(let part of info.fileList){
                           
                            this.paymentForm.data.attachment.push(part.response.data);
                        }
						this.$message.success(`${info.file.name} 上传成功`);
					} else {
						this.$message.error(`${info.file.name} 上传失败`);
					}
					this.uploading = false
				} else if (status === 'error') {
				}
			},
            changeType(){
                this.page.page = 1
                this.getProceedsRecord()
            }
		}
	})

</script>

<style scoped>
.editable-row-operations a {
  margin-right: 8px;
}
</style>